import { makeStyles, Typography } from "@material-ui/core"
import { FC, useEffect, useState } from "react"
import {
  GetSuperviseesBySupervisorIdDocument,
  GetSuperviseesBySupervisorIdQuery,
  GetSuperviseesBySupervisorIdQueryVariables,
} from "../../generated/graphql"
import { useGraphQLClient } from "../../hooks/useGraphQLClient"
import { useSession } from "../../hooks/useSession"
import { colors } from "../../utils/theme"
import { HeaderHeight } from "../molecules/Header"
import PractitionerTable from "../molecules/PractitionerTable"

const useStyles = makeStyles((theme) => ({
  myClients: {
    padding: theme.spacing(3),
    paddingTop: HeaderHeight + theme.spacing(3),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    backgroundColor: colors.neutral.white,
    flex: 1,
  },
  content: {
    maxWidth: 1440,
    margin: "0 auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(3),
  },
  title: {
    marginRight: theme.spacing(2),
  },
  addClientButton: {
    width: 188,
  },
  navigation: {
    height: 92,
    width: "fit-content",
    display: "flex",
    alignItems: "center",
    padding: 0,
    margin: 0,
    border: 0,
    backgroundColor: "transparent",
    cursor: "pointer",
    paddingLeft: theme.spacing(3),
    outline: "none",
  },
  chevron: {
    marginLeft: 4,
  },
  noData: {
    width: "100%",
    padding: 27,
    textAlign: "center",
    border: `1px solid ${colors.neutral.clay}`,
    borderTop: 0,
    backgroundColor: colors.neutral.white,
  },
}))

const MyPractitioners: FC = () => {
  const classes = useStyles()
  const { session } = useSession()
  const graphqlClient = useGraphQLClient()

  const [data, setData] = useState<any>(null)
  useEffect(() => {
    if (session) {
      const fetchPractitioners = async () => {
        const practitioners = await graphqlClient.request<
          GetSuperviseesBySupervisorIdQuery,
          GetSuperviseesBySupervisorIdQueryVariables
        >(GetSuperviseesBySupervisorIdDocument, {
          userId: session?.userId,
        })
        setData(
          practitioners.organization_supervisors?.[0]
            ?.organization_supervisors_organization_supervisees || []
        )
      }
      fetchPractitioners()
    }
  }, [session?.userId])

  return (
    <>
      <div className={classes.myClients}>
        <div className={classes.content}>
          <div className={classes.header}>
            <Typography variant="h2" component="h1" className={classes.title}>
              Practitioners
            </Typography>
          </div>

          <div>
            <PractitionerTable practitioners={data} />
            {data && data.length === 0 && (
              <div className={classes.noData}>
                <Typography variant="body1">
                  You currently do not have any practitioners listed on your
                  dashboard.
                </Typography>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default MyPractitioners
